export default __webpack_public_path__ + "static/media/header-bg.88f43026.png";